import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
    selector: 'secret',
    templateUrl: './secret.component.html',
    styleUrls: ['./secret.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class SecretComponent implements OnInit {

    secretForm: FormGroup;
    secretCode: any;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private parseService: ParseService,
        private toastr: ToastrService,
        private router: Router,
        private storageConfiguration: StorageConfiguration

    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.secretForm = this._formBuilder.group({
            password: ['', Validators.required]
        });
        this.getSecretCode()
    }

    async getSecretCode() {
        let queryInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', "GkwnrBXurP");
        await query.find().then(results => {
            let result = results[0];
            this.secretCode = result.get('registerSecretCode');
        });
    }

    onSubmit() {
        var enterredCode = this.secretForm.value.password;
        if (enterredCode == this.secretCode) {
            this.storageConfiguration.sessionSetItem(this.storageConfiguration.isloggedIn, 'true');
            this.toastr.success("Code verified successfully");
            this.router.navigate(['register']);
        } else {
            this.toastr.error("Please enter valid Code")
        }
    }

}
